import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import { Col, Button, Form } from 'antd';

import {
    required
} from "./validDesc";
import {
    TextField
} from 'redux-form-antd'
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 },
    },
};
const FormItem = Form.Item;
const LoginForm = props => {
    const { handleSubmit } = props;
    return (
        <form onSubmit={handleSubmit} noValidate >
            <Col md={24}>
                <Field  {...formItemLayout} validate={[required]} component={TextField} label="帳號"
                    name="login" type="text" placeholder="請輸入學生身分證字號"   ></Field>
                <Field  {...formItemLayout} validate={[required]} component={TextField} label="密碼"
                    name="password" type="password"
                    placeholder=" 密碼為出生年月日的組合,如1911/01/01出生，則密碼為19110101"
                ></Field>
                <FormItem
                    wrapperCol={
                        {
                            xs: { span: 24 },
                            sm: { span: 22, offset: 2},
                        }
                    }
                >
                    <Button htmlType="submit" size='large' style={{ width: '100%', marginTop: '10px' }}>
                        送出
                    </Button>
                </FormItem>
                <br />

            </Col>
        </form>
    )
}
export default reduxForm({
    form: 'teacherLogin', // a unique identifier for this form
})(LoginForm)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DeviseContainer/LoginContainer/LoginForm.jsx